import { api } from "@/api"

import type { MaybeRef } from "@vueuse/core"
import { useQuery, useQueries } from "@tanstack/vue-query"
import type { ReportQuery } from "./reportQuery"

export type TopProductsReportDatapoint = DeepReadonly<{
  productName: string
  soldCount: number
  revenue: number
}>

export type TopProductsReport = DeepReadonly<{
  dataset: TopProductsReportDatapoint[]
}>

export type TopProductsReportQuery = ReportQuery & {
  categoryId?: string
  productTagId?: string
}
export const retrieveTopProductsReport = async (
  query: TopProductsReportQuery
): Promise<TopProductsReport> => {
  const { body } = await api.get<TopProductsReport>(
    "/reports/products/",
    {
      query: query,
    }
  )
  return body
}

export const useTopProductsReport = (
  query: MaybeRef<TopProductsReportQuery>
) =>
  useQuery(
    [BASE_TOP_PRODUCTS_REPORT_QUERY_KEY, query] as const,
    ({ queryKey: [_name, query_] }) =>
      retrieveTopProductsReport(unref(query_)),
    { refetchInterval: 60 * 1000 }
  )

export const useTopProductsReports = (
  queries: MaybeRef<MaybeRef<TopProductsReportQuery>[]>
) =>
  useQueries({
    queries: computed(() =>
      unref(queries).map((query) => ({
        queryKey: [
          BASE_TOP_PRODUCTS_REPORT_QUERY_KEY,
          unref(query),
        ],
        queryFn: () =>
          retrieveTopProductsReport(unref(query)),
        refetchInterval: 60 * 1000,
      }))
    ),
  })
